export const DETAILS_ADDRESS_EDITING = 'DETAILS_ADDRESS_EDITING'
export const DETAILS_ADDRESS_EDITING_COMPLETED = 'DETAILS_ADDRESS_EDITING_COMPLETED'

export const DETAILS_LOADED = 'DETAILS_LOADED'


// WEBPACK FOOTER //
// ./src/gov-care-registration-details/constants.js